module.exports = __webpack_public_path__ + "static/media/b_dashboard.4ebcf1de.png";